import {
  each,
  get,
  isArray,
  isBoolean,
  isDate,
  isNumber,
  isString,
  map,
  omit,
  reduce,
  size,
} from "lodash";
import { parse as qParse, stringify as qStringify } from "query-string";
import { isDateMath, isMoment, mmt } from "@tootools/date";

const stringifyDate = (date: any) => {
  return mmt(date).toISOString(false);
};

export function parse(query: string) {
  const parsedQuery: Record<string, unknown> = {};
  each(qParse(query), (parsedValue, key) => {
    if (isArray(parsedValue)) {
      parsedQuery[key] = map(parsedValue, getValidParsedValue);
    } else if (parsedValue) {
      parsedQuery[key] = getValidParsedValue(parsedValue);
    }
  });
  return parsedQuery;
}

function getValidParsedValue(parsedValue: string) {
  const numberValue = parseInt(parsedValue);
  if (isNaN(numberValue)) {
    return getParsedValueFromString(parsedValue);
  }
  return getParsedValueFromNumber(numberValue, parsedValue);
}

function getParsedValueFromString(parsedValue: string) {
  try {
    return JSON.parse(parsedValue);
  } catch (e) {
    return parsedValue;
  }
}

function getParsedValueFromNumber(numberValue: number, parsedValue: string) {
  if ("" + numberValue === parsedValue) {
    return numberValue;
  } else {
    return parsedValue;
  }
}

export function stringify(object: Record<string, any>, encode: boolean = true) {
  return qStringify(
    reduce(
      object,
      (acc, value, key) => {
        if (isString(value) || isNumber(value) || isBoolean(value)) {
          acc[key] = value;
        } else {
          acc[key] = JSON.stringify(value);
        }
        return acc;
      },
      {} as Record<string, any>
    ),
    { encode }
  );
}

export function getUrl(
  pathname: string,
  params: Record<string, unknown>,
  encode: boolean = true
) {
  const getFormatedValue = (value: any): string => {
    if (isString(value) && isDateMath(value)) {
      return value;
    } else if (isDate(value) || isMoment(value)) {
      return stringifyDate(value);
    } else if (isString(value) || isNumber(value)) {
      return "" + value;
    } else if (isArray(value)) {
      return "[" + value + "]";
    } else {
      return get(value, "id", "");
    }
  };
  const replacedTokens: string[] = [];
  const processedPathName = reduce(
    params,
    (acc, value, token: string) => {
      const key = ":" + token;
      if (acc.indexOf(key) !== -1) {
        replacedTokens.push(token);
        return acc.replace(key, getFormatedValue(value));
      } else {
        return acc;
      }
    },
    pathname
  );
  const searchParams = omit(params, replacedTokens);
  if (size(searchParams)) {
    return processedPathName + "?" + stringify(searchParams, encode);
  } else {
    return processedPathName;
  }
}
